<template>
	<v-card
		id='filter-list'
		ref='filter-list'
		class='shadow no-text-highlight pa-0 mb-9 filter-class'
	>

		<v-card-text class='pa-0 ma-0'>

			<v-list
				class='pa-0 ma-0'
				style='padding-top: 3px'
				elevation='0'
				two-line
			>
				<v-list-item
					class='list-item'
					:ripple='true'
				>
					<v-list-item-content class='primary--text'>

						<v-row
							align='center'
							justify='space-between'
							no-gutters
							style='width: 100%'
						>
							<v-col cols='12'>

								<div class='d-flex justify-space-between align-center mt-1'>
									<span class='font-weight-bold pr-2'> Für Geschäftskunden </span>
								</div>
							</v-col>

							<v-col class='mt-1 pr-4' cols='12'>
								<div class='text-ellipsis' style='font-size: 12px; color: #989ca5;'>
									<v-checkbox
										v-model='isBusiness'
										label='Nettopreise anzeigen'
										color='#C62929'
										hide-details
										:ripple='false'
										class='v-check font-weight-regular'
									/>
								</div>

							</v-col>
						</v-row>

					</v-list-item-content>
				</v-list-item>


			</v-list>
		</v-card-text>

	</v-card>
</template>

<script>
export default {
  name: 'OptionList',
  components: {},
  data() {
    return {
      isBusiness: false
    }
  },
  watch: {
    isBusiness: function(val) {
      this.$store.isBusinessCustomer = val;
      this.$bus.$emit('filters-updated');
    }
  },
  mounted() {
    this.isBusiness = this.$store.isBusinessCustomer;
  },
  methods: {
  }
}
</script>

<style lang='scss'>
@import 'src/styles/variables';


#filter-list {
  padding-bottom: 6px !important;

  .v-list-item__content > * {
    line-height: 1.3 !important;
  }

  .v-list-item__content {
    padding: 12px 0 !important;
    min-height: 60px !important;
    font-size: 13.5px !important;
  }

  .v-list-item.list-item {
    padding: 0 18px;
    min-height: 69px;
  }

  #header {
    border-top-left-radius: $border-radius-root;
    border-top-right-radius: $border-radius-root;
    padding: 0 12px;
    font-size: 19px;
    width: 100%;

    .v-toolbar__content {
      width: 100%;
      font-weight: 600;
      justify-content: center;
    }

    &.v-app-bar--is-scrolled {
      box-shadow: none !important;
      border-bottom: 1.6px solid black !important;
    }

  }
  .overlay-active {
    z-index: 1500;
    background-color: white;
  }
}
.filter-dialog {
  contain: inherit;
  overflow: inherit;
  display:block;
  &::before {
    content: "";
    width: 0px;
    height: 0px;
    position: absolute;
    border-left: 20px solid transparent;
    border-right: 20px solid #FFFFFF;
    border-top: 20px solid transparent;
    border-bottom: 20px solid transparent;
    left: -39px;
    top: 134px;
  }
}
.v-check {
  margin-top: 0 !important;
  label {
    font-size: 14px;
    color: #0064F6 !important;
  }
}
</style>